// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + "store" + "." + "b2954c54" + ".chunk.js");